// removed by extract-text-webpack-plugin
module.exports = {"order":"G789b2d Gdb0483 Ge6ea4d undefined","calendar":"G68503e G7e254b Gb69063 G149cfa Geb3fca G4fae24 G34a078","left":"G8046c4","right":"Gcf1b52","infoLine":"G402c56"};